<template>
  <b-modal
    modal-class="component-modal-product"
    id="transferDetailItemModal"
    ref="transferDetailItemModal"
    size="xl"
    :title="modalTitle"
    no-close-on-backdrop
    @close="close"
    :hide-footer="!isTransferInAction"
    scrollable
  >
    <div v-if="transferDetail" class="grid-modal">
      <div class="layout-modal-left">
        <div class="layout-row">
          <div class="layout-row-item-label">รหัสใบโอนสินค้า:</div>
          <div class="layout-row-item-value">
            {{ transferDetail.transferNo }}
          </div>
        </div>
        <div class="layout-row">
          <div class="layout-row-item-label">วันที่ทำรายการ:</div>
          <div class="layout-row-item-value">
            {{ formatDate(transferDetail.transferActionDate) }}
          </div>
        </div>
        <div class="layout-row">
          <div class="layout-row-item-label">สาขาต้นทาง:</div>
          <div class="layout-row-item-value">
            {{ transferDetail.transferSourceBranchName }}
          </div>
        </div>
        <div class="layout-row">
          <div class="layout-row-item-label">สาขาปลายทาง:</div>
          <div class="layout-row-item-value">
            {{ transferDetail?.transferDestinationBranchName }}
          </div>
        </div>
      </div>
      <div class="layout-modal-right">
        <b-table
          id="transferDetailTable"
          ref="transferDetailTable"
          hover
          small
          head-variant="light"
          :items="transferItemsWithImage"
          :fields="fields"
          :filter="filter"
          :sort-desc="true"
          :responsive="true"
        >
          <template v-slot:cell(index)="row">{{ row.index + 1 }}.</template>
          <template v-slot:cell(image)="row">
            <ProductImage :src="row.item.imageUrl || null" />
          </template>
          <template v-slot:cell(productQty)="row">
            {{ qtyDisplay(row.item) }}
          </template>
          <template v-slot:cell(productUnit)="row">
            {{ uomDisplay(row.item) }}
          </template>
        </b-table>
      </div>
    </div>
    <template v-if="isTransferInAction" v-slot:modal-footer>
      <b-button variant="danger" @click="updateTransferInStatusItem('REJECT')"
        >ปฏิเสธการรับโอน</b-button
      >
      <b-button
        type="submit"
        variant="primary"
        @click="updateTransferInStatusItem('APPROVE')"
      >
        ยืนยันการรับโอน
      </b-button>
    </template>

    <Dialog ref="Dialog"></Dialog>
    <Loading v-if="isLoading"></Loading>
  </b-modal>
</template>

<script>
import Dialog from "@/components/modal/Dialog";
import Loading from "@/components/Loading";
import "@/theme/modal/ProductAndStock/Product.scss";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import ProductImage from "@/components/table/stock/component/ProductImage.vue";
import { formatUomWithBase } from "@/utils/uomConversion";

export default {
  name: "TransferDetailItemModal",
  components: {
    Dialog,
    Loading,
    ProductImage,
  },
  data() {
    return {
      isLoading: false,
      modalTitle: "ใบโอนสินค้า",
      transferDetail: null,
      isTransferInAction: false,
      isIncoming: false,
      actionTransfer: "",
      fields: [
        {
          key: "index",
          label: "",
          thStyle: { width: "5%" },
          tdStyle: { width: "5%" },
        },
        {
          key: "image",
          label: "",
          thStyle: { width: "5%" },
        },
        {
          key: "productCode",
          label: "รหัส",
          thStyle: { width: "18%" },
          tdStyle: { width: "18%" },
          tdClass: "text-nowrap code-cell",
        },
        {
          key: "productNameMain",
          label: "ชื่อสินค้า",
          thStyle: { width: "31%" },
          tdStyle: { width: "31%" },
        },
        {
          key: "productQty",
          label: "จำนวนสินค้า",
          thStyle: { width: "27%" },
          tdStyle: { width: "27%" },
          class: "text-right",
        },
        {
          key: "productUnit",
          label: "หน่วยสินค้า",
          thStyle: { width: "19%" },
          tdStyle: { width: "19%" },
        },
      ],
      filter: null,
    };
  },
  computed: {
    ...mapGetters({
      getTransferList: "moduleTransferInventory/getTransferList",
      getProductList: "moduleProductInventory/getProductList",
    }),
    transferItemsWithImage() {
      if (!this.transferDetail?.transferProductItems) return [];
      return this.transferDetail.transferProductItems.map(item => ({
        ...item,
        imageUrl:
          this.getProductList.find(
            p =>
              p.productId === item.productId ||
              p.productCode === item.productCode
          )?.imageUrl || null,
      }));
    },
  },
  methods: {
    ...mapActions({
      fetchTransferList: "moduleTransferInventory/fetchTransferList",
    }),
    async show(data) {
      const { transferDetail, isTransferInAction, isIncoming } = data;
      this.transferDetail = transferDetail;
      this.isTransferInAction = isTransferInAction ?? false;
      this.isIncoming = isIncoming ?? false;

      this.$bvModal.show("transferDetailItemModal");
    },
    close() {
      this.isTransferInAction = false;
      this.isIncoming = false;
      this.$bvModal.hide("transferDetailItemModal");
    },
    formatDate(date) {
      if (date) {
        return moment(date).locale("th").format("D MMM YY");
      } else {
        return "";
      }
    },
    updateTransferInStatusItem(actionTransfer) {
      this.$refs.Dialog.showAlertConfirm(
        actionTransfer === "APPROVE"
          ? "ยืนยันการรับโอนนี้ ?"
          : "ปฏิเสธการรับโอนนี้ ?",
        actionTransfer === "APPROVE"
          ? "คุณต้องการยืนยันการรับโอนนี้ใช่หรือไม่"
          : "คุณต้องการปฏิเสธการรับโอนนี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;
        this.actionTransfer = actionTransfer;

        const transferIdBody = {
          action: this.actionTransfer,
        };
        this.$store
          .dispatch("moduleTransferInventory/updateTransferInStatusItem", {
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: this.$route.params.branchUrl,
            id: this.transferDetail.transferId,
            actionTransfer: transferIdBody,
          })
          .then(res => {
            if (res.status == 200) {
              this.$parent.showDialogToast(
                "success",
                actionTransfer === "APPROVE"
                  ? "ยืนยันการรับโอนสินค้าสำเร็จ"
                  : "ปฏิเสธการรับโอนสินค้าสำเร็จ"
              );

              this.reloadTransferList();
              this.close();
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;

            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : actionTransfer === "APPROVE"
                ? "ยืนยันการรับโอนสินค้าไม่สำเร็จ กรุณาลองใหม่"
                : "ปฏิเสธการรับโอนสินค้าไม่สำเร็จ กรุณาลองใหม่";

            this.$parent.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    reloadTransferList() {
      this.fetchTransferList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      });
    },
    signedQtyText(value) {
      if (value === null || value === undefined || value === "") return "-";
      const num = Number(value);
      if (Number.isNaN(num)) return String(value);
      const formatted = Math.abs(num).toLocaleString("en-US");
      return this.isIncoming ? `+${formatted}` : `-${formatted}`;
    },
    qtyDisplay(item) {
      const main = this.signedQtyText(item.productQty);
      if (item.qtyBaseUom == null) return main;
      return `${main}(${this.signedQtyText(item.qtyBaseUom)})`;
    },
    uomDisplay(item) {
      return formatUomWithBase(item.productUnit, item.baseUomName);
    },
  },
};
</script>

<style scoped>
.grid-modal {
  display: grid;
  grid-template-columns: 32% 68%;
}

.layout-modal-left {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-right: 1px solid #dee2e6;
  padding-right: 16px;
}

.layout-modal-right {
  padding-left: 16px;
}

.layout-row {
  display: flex;
  gap: 8px;
}

@media (max-width: 750px) {
  .layout-row {
    flex-direction: column;
  }
}

.layout-row-item-label {
  font-weight: 600;
  color: #212529;
  white-space: nowrap;
}

.layout-row-item-value {
  font-weight: 400;
  color: #212529;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

::v-deep .modal-body {
  padding: 16px 24px 24px 24px !important;
}

::v-deep #transferDetailTable tbody tr td {
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #transferDetailTable thead tr th,
::v-deep #transferDetailTable tbody tr td {
  vertical-align: middle !important;
}
</style>
